/* -------------------------------------------------------------------------- */
/*                                Dependencies                                */
/* -------------------------------------------------------------------------- */

// Mantine
import { Box } from '@mantine/core';

// Styles
import classes from './SelectionCard.module.css';

//svgs
import { Text, Title } from '@components/v2/ui';

/* -------------------------------------------------------------------------- */
/* Interface                                 */
/* -------------------------------------------------------------------------- */

type TSelectionCardProps = {
	title: string;
	description: string;
	icon: string;
	onClick?: () => void;
};

/* -------------------------------------------------------------------------- */
/*                                  Component                                 */
/* -------------------------------------------------------------------------- */
export const SelectionCard = ({
	title,
	description,
	icon,
	onClick,
}: TSelectionCardProps) => {
	return (
		<Box
			onClick={onClick}
			className={classes['container']}
		>
			<img src={icon} alt="Logo-inuk" width={'85px'} />
			<Title
				mt={'12px'}
				mb={'16px'}
				order={6}
				c={'#1D3965'}
			>
				{title}
			</Title>
			<Text variant="body2" c={'#9BA6B7'}>
				{description}
			</Text>
		</Box>
	);
};
